import { combineReducers } from 'redux';

import {
  ACTION_ADD_AFFILIATED_WEBMASTERS,
} from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_AFFILIATED_WEBMASTERS:
      return { ...state, ...action.payload.affiliatedWebmasters };

    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
